import { Brand } from '../../components/Brand';
export function LandingFooter() {
  return (
    <footer className="wf-footer">
      <Brand />
      <span>© 2026 Waterfall · Research preview</span>
    </footer>
  );
}
